/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuditLogDto } from './AuditLogDto';
import type { CharityDto } from './CharityDto';
import type { SolicitorDto } from './SolicitorDto';
import type { SupporterDto } from './SupporterDto';
import type { UserEmailVerificationDto } from './UserEmailVerificationDto';
import type { UserPasswordResetDto } from './UserPasswordResetDto';
import type { UserSessionDto } from './UserSessionDto';
export type UserDto = {
    id: string;
    email: string;
    password_hash: string;
    first_name: string;
    last_name: string;
    phone: string;
    role: UserDto.role;
    status: UserDto.status;
    email_verified?: boolean;
    email_verified_at?: string;
    last_login_at?: string;
    created_at: string;
    updated_at: string;
    solicitor?: SolicitorDto;
    charity?: CharityDto;
    supporter?: SupporterDto;
    sessions?: Array<UserSessionDto>;
    password_resets?: Array<UserPasswordResetDto>;
    email_verifications?: Array<UserEmailVerificationDto>;
    audit_logs?: Array<AuditLogDto>;
};
export namespace UserDto {
    export enum role {
        SUPPORTER = 'SUPPORTER',
        SOLICITOR = 'SOLICITOR',
        CHARITY = 'CHARITY',
        SUPER_ADMIN = 'SUPER_ADMIN',
        ADMIN = 'ADMIN',
        READ_ONLY = 'READ_ONLY',
    }
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
        PENDING = 'PENDING',
        VERIFICATION = 'VERIFICATION',
        SUSPENDED = 'SUSPENDED',
    }
}

